jQuery(document).ready(function() {
    /*jQuery('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if (jQuery('#agree').is(':checked')) {
        jQuery(this).submit();
      }
      else {
        alert("Debes aceptar la política de privacidad y las condiciones de compra.");
        return false;
      }
    });*/
  jQuery('body').on('click', '.newsletter-submit, .contact-form-submit', function() {
      if (jQuery('#agree-newsletter').is(':checked')) {
        jQuery(this).submit();
      }
      else {
        alert("Debes aceptar la política de privacidad.");
        return false;
      }
    });
  jQuery('body').on('click', '.submit-cvo', function() {
      if ( (jQuery('#agree-newsletter-vo').is(':checked')) && (jQuery('#agree-cvo').is(':checked')) ) {
        jQuery(this).submit();
      }
      else {
        alert("Debes confirmar tu suscripción a la newsletter, así como aceptar el aviso legal y la política de privacidad.");
        return false;
      }
    });
  jQuery('body').on('click', '.cc-popup-form-submit', function() {
      if (jQuery('#agree-newsletter-popup').is(':checked')) {
        jQuery(this).submit();
      }
      else {
        alert("Debes aceptar la política de privacidad.");
        return false;
      }
    });
  jQuery(".page-template-product td").each(function(){
    if ( jQuery('span:contains("<!--gold-->")').replaceWith("<i class='fas fa-award gold'></i>"));
    if ( jQuery('span:contains("<!--silver-->")').replaceWith("<i class='fas fa-award silver'></i>"));
    if ( jQuery('span:contains("<!--bronze-->")').replaceWith("<i class='fas fa-award bronze'></i>"));
  });
});